// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","grid":"Footer_grid__rFMWx","logo":"Footer_logo__+JiYo","bottom":"Footer_bottom__7buk6"};